export const MinMrt = 60;
export const MaxMrt = 1209600;

export const SENTRY_DSN = 'https://fd62c54b7d0d4a798d3995f67d9f97a0@sentry-prod.monit.onereach.ai/24';

export enum TableColumns {
  NAME = 'Queue name',
  RETURN_POLICY = 'Return policy',
  ITEM_RETENTION_TIME = 'Item retention time',
  DATE_CREATED = 'Date created',
}

export enum MonitoringColumns {
  NUMBER_OF_AVAILABLE_ITEMS = 'Number of available items',
  NUMBER_OF_CURRENT_ITEMS = 'Number of "in flight" items',
  NUMBER_OF_DELETED_ITEMS = 'Number of deleted items',
}

export const PERIODS_MONITORING = [
  'Last 1 hour',
  'Last 3 hours',
  'Last 6 hours',
  'Last 12 hours',
  'Last 24 hours',
  'Last 3 days',
  'Last 1 week',
  'Last 2 weeks',
];

export const SCALE_MONITORING_FOR_1_HOUR = [
  '5 min',
  '15 min',
  '30 min',
];

export const SCALE_MONITORING_FOR_3_HOURS = [
  '5 min',
  '15 min',
  '30 min',
  '1 hour',
];
export const SCALE_MONITORING_FOR_HOURS = [
  '5 min',
  '15 min',
  '30 min',
  '1 hour',
  '3 hours',
];

export const SCALE_MONITORING = [
  '5 min',
  '15 min',
  '30 min',
  '1 hour',
  '3 hours',
  '1 day',
];

export const CHART_NAME = [
  'ApproximateNumberOfMessagesVisible',
  'ApproximateNumberOfMessagesNotVisible',
  'NumberOfMessagesDeleted',
];


